import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../../../../backendServer';
import { axiosBaseQuery } from '../../../../../store/utility';
import { Diagnostic } from '../Diagnostic/types';

export const diagnosticsAPI = createApi({
    reducerPath: 'diagnosticsAPI',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/diagnostic/' }),
    tagTypes: ['Diagnostic', 'LastDiagnostic', 'DiagnosticMetadata'],
    endpoints: (builder) => ({
        getDiagnostics: builder.query({
            query: (params) => ({
                url: '',
                method: 'GET',
                withCredentials: true,
                params: params,
            }),
            providesTags: (query) => {
                const results = query?.results ?? query;
                return results
                    ? [
                          ...results.map((diagnostic: Diagnostic) => ({ type: 'Diagnostic', id: diagnostic.id })),
                          'Diagnostic',
                      ]
                    : ['Diagnostic'];
            },
        }),
        getDiagnosticById: builder.query({
            query: (id) => ({
                url: `${id}/`,
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: (result) => {
                return result ? [{ type: 'Diagnostic', id: result.id }] : ['Diagnostic'];
            },
        }),
        getDiagnosticTracking: builder.query({
            query: (params) => ({
                url: 'tracking/',
                method: 'GET',
                withCredentials: true,
                params: params,
            }),
            providesTags: (query) => {
                const results = query?.results ?? query;
                return results
                    ? [
                          ...results.map((diagnostic: Diagnostic) => ({ type: 'Diagnostic', id: diagnostic.id })),
                          'Diagnostic',
                      ]
                    : ['Diagnostic'];
            },
        }),
        getDiagnosticMetadata: builder.query({
            query: (params) => ({
                url: 'metadata/',
                method: 'GET',
                withCredentials: true,
                params: params,
            }),
            providesTags: (result) => ['DiagnosticMetadata'],
        }),
    }),
});
